// 国枝さん作成コード
// 名入れのボタンを選択したら、名入れフォームが出現

$(function(){

    //表示・非表示の関数
    let checkNaire = function(){
        let naire = $('input[name="名入れの選択"]:checked').val();
        if(naire == "名入れ無し") {
            //フォントとお名前のDIVを非表示にする
            $('select[name="properties[名入れのフォントの選択]"]').parents('div').eq(0).hide();
            $('input[name="properties[お名前]').parents('div').eq(0).hide();

            //フォントとお名前を無効にする
            $('select[name="properties[名入れのフォントの選択]"]').prop('disabled', true);
            $('input[name="properties[お名前]').prop('disabled', true);
        }else{
            //フォントとお名前のDIVを表示する
            $('select[name="properties[名入れのフォントの選択]"]').parents('div').eq(0).show();
            $('input[name="properties[お名前]').parents('div').eq(0).show();

            //フォントとお名前を有効にする
            $('select[name="properties[名入れのフォントの選択]"]').prop('disabled', false);
            $('input[name="properties[お名前]').prop('disabled', false);
        }
    };

    //ページ読み込み時に処理
    checkNaire();

    //名入れの選択時に処理
    $('input[name="名入れの選択"]').click( function(){ checkNaire(); } );


});





// 三輪追記　カートにフォントの選択を表示しない 上手くいかない


// allowDrinksCheckbox.addEventListener("change", function(event) {
//   if (event.target.checked) {
//     naire.disabled = false;
//   } else {
//     naire.disabled = true;
//   }
// }, false);